<!-- eslint-disable max-len -->
<template>
  <div class="dataset-page-query-container">
    <div
      v-if="modeQuery === 'update' && querySelected"
      class="container-name-query-selected">
      <img
        :src="require('@/assets/icon/query/query-saved.svg')"
        width="17">
      {{ querySelected.name }}
    </div>

    <div
      v-if="modeQuery === 'create'"
      class="floating-type-query">
      <div
        :class="{ 'content-type-active' : query_type === 'sql' }"
        class="content-type m__r--10"
        @click="query_type = 'sql'">SQL</div>
    </div>
    <div
      v-if="modeQuery === 'update' && querySelected && querySelected.query_type"
      class="floating-type-query floating-type-query__update">
      <div
        v-show="querySelected.query_type === 'sql'"
        :class="{ 'content-type-active' : querySelected.query_type === 'sql' }"
        class="content-type m__r--10">SQL</div>
    </div>

    <j-monaco-editor
      ref="queryEditor"
      :value="dataQuery"
      language="sql"
      height="200px"
    />

    <div class="block-action">
      <div
        class="btn-blue-query m__r--10"
        @click="actionRunQuery">
        <img
          :src="require('@/assets/icon/query/run.svg')"
          width="13">
        Run Query
      </div>
      <div
        v-click-outside="hide"
        class="btn-grey-query m__r--10"
        @click="openSaveQuery">
        <img
          :src="require('@/assets/icon/query/save.svg')"
          width="13">
        Save Query
      </div>
      <div
        class="btn-grey-query"
        @click="openListQuery">
        <img
          :src="require('@/assets/icon/query/open.svg')"
          width="13">
        Open Saved Query
      </div>
      <label class="label-limit">Limit</label>
      <div class="btn-limit">
        <j-single-select
          v-model="select_limit"
          :options="options_limit"
          :error-required="false"
          placeholder="Limit"
          label="name" />
      </div>

      <div
        v-show="opened"
        class="popup-query">
        <div
          class="list-action"
          @click="actionUpdateQuery">Update query</div>
        <div
          class="list-action"
          @click="openSaveAsQuery">Save as new query</div>
      </div>
    </div>

    <div v-if="showResult">
      <div class="d-flex p__t--15 p__l--20">
        <div class="query-result">Query Result</div>
        <div
          class="btn-grey-query"
          @click="$refs.saveResultModal.show()">
          Save Result
        </div>
      </div>

      <v-client-table
        :data="dataResult"
        :columns="columns"
        :options="table_options"
        class="jTable">
        <div
          v-for="(i, index) in columns"
          slot-scope="props"
          :key="index"
          :slot="i">
          {{ cekTypeColumn(i) === 'boolean' ? (props.row[i] ? 'true' : 'false') : props.row[i] }}
        </div>
      </v-client-table>
    </div>

    <b-modal
      ref="saveQueryModal"
      class="mod-form modal-add-record-data"
      centered
      no-close-on-esc
      no-close-on-backdrop>
      <div class="label-create-form-data">SAVE NEW QUERY</div>
      <b-form-group :class="{'error-input' : $v.query_name.$error}">
        <label> Name </label>
        <j-input
          v-model="$v.query_name.$model"
          :error-required="$v.query_name.$error"
          :max-length="255"/>
      </b-form-group>
      <br>
      <b-row>
        <b-col md="12">
          <div class="float-to-right">
            <b-button
              class="btn gray m__r--5"
              @click="closeModalSave">
              Close
            </b-button>
            <b-button
              class="btn blue"
              @click="createNewQuery">
              Save
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      ref="listSavedQueryModal"
      class="mod-form modal-add-record-data"
      centered
      no-close-on-esc
      no-close-on-backdrop>
      <div class="label-create-form-data">OPEN SAVED QUERY</div>

      <div
        v-if="listQuerySaved.length > 0"
        class="container-list-query-saved">
        <div
          v-for="(item, index) in listQuerySaved"
          :key="index"
          :class="{ 'm__t--10' : index > 0,
                    'list-query-active' : item.id === (querySelected ? querySelected.id : '') }"
          class="list-query"
          @click="querySelected = item">
          <img
            :src="require(`@/assets/icon/query/radio-${item.id === (querySelected ? querySelected.id : '') ? 'on' : 'off'}.svg`)"
            width="20">
          <div class="m__l--10">
            <div class="label-query">{{ item.name }}</div>
            <div class="d-flex">
              <div
                v-show="item.query_type"
                class="content-type-query">{{ item.query_type }}</div>
              <div class="id-query">#{{ item.id }}</div>
            </div>
          </div>
          <img
            :src="require('@/assets/icon/query/delete.svg')"
            class="img-delete"
            width="13"
            @click="actionDeleteQuery(item)">
        </div>
      </div>
      <div v-else>No data option</div>

      <b-row>
        <b-col md="12">
          <div class="float-to-right">
            <b-button
              class="btn gray m__r--5"
              @click="closeModalListSaved">
              Close
            </b-button>
            <b-button
              :disabled="!querySelected"
              class="btn blue"
              @click="openQuerySelected">
              Open
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      ref="saveResultModal"
      class="mod-form modal-add-record-data"
      centered
      no-close-on-esc
      no-close-on-backdrop>
      <div class="label-create-form-data">SAVE RESULT TO DATASET</div>

      <label> Action </label>
      <div class="d-flex m__b--10">
        <div
          :class="typeMode === 'merge' ? 'option-active' : ''"
          class="container-option-save-result result-label d-flex m__r--15"
          @click="typeMode = 'merge'">
          <img
            :src="require(`@/assets/icon/query/merge-data-${typeMode === 'merge' ? 'on' : 'off'}.svg`)"
            class="m__t--3 m__r--5"
            height="17">
          <div class="text-option">Append Data</div>
        </div>
        <div
          :class="typeMode === 'replace' ? 'option-active' : ''"
          class="container-option-save-result result-label d-flex"
          @click="typeMode = 'replace'">
          <img
            :src="require(`@/assets/icon/query/replace-data-${typeMode === 'replace' ? 'on' : 'off'}.svg`)"
            class="m__t--3 m__r--5"
            height="17">
          <div class="text-option">Replace Data</div>
        </div>
      </div>

      <b-form-group :class="{'error-input' : $v.data_save_result.group.$error}">
        <label> Dataset Group </label>
        <j-single-select
          v-model="$v.data_save_result.group.$model"
          :error-required="$v.data_save_result.group.$error"
          :options="datasetGroupOptions"
          placeholder="Select Dataset Group"
          value-format="object"
          label="name"/>
      </b-form-group>

      <b-form-group :class="{'error-input' : $v.data_save_result.dataset.$error, 'm__t--10' : !$v.data_save_result.dataset.$error}">
        <label> Dataset </label>
        <j-single-select
          v-model="$v.data_save_result.dataset.$model"
          :error-required="$v.data_save_result.dataset.$error"
          :disabled="!data_save_result.group"
          :options="datasetOptions"
          placeholder="Select Dataset"
          value-format="object"
          label="name"/>
      </b-form-group>

      <div class="float-to-right m__t--15">
        <b-button
          class="btn gray m__r--5"
          @click="closeModalSaveResult">
          Close
        </b-button>
        <b-button
          :disabled="!typeMode || !data_save_result.group || !data_save_result.dataset"
          class="btn blue"
          @click="actionSaveResultQuery">
          Save
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies, no-nested-ternary, max-len, no-console, no-unused-vars */
import { required, requiredIf } from 'vuelidate/lib/validators';
import { mapState, mapActions, mapMutations } from 'vuex';
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import ClickOutside from 'vue-click-outside';
import jMonacoEditor from '@/components/monaco-editor/jMonacoEditor';

export default {
  // eslint-disable-next-line
  name: 'jDatasetQuery',
  components: {
    jMonacoEditor,
  },
  directives: {
    ClickOutside,
  },
  data() {
    return {
      dataQuery: '\n\n\n\n\n\n\n\n',
      opened: false,
      datasetDetail: null,
      datasetColumn: [],
      query_name: null,
      modeQuery: 'create',
      typeMode: '',
      querySelected: null,
      listQuerySaved: [],
      select_limit: 1000,
      options_limit: [
        { id: 50, name: 50 },
        { id: 100, name: 100 },
        { id: 500, name: 500 },
        { id: 1000, name: 1000 },
      ],
      data_save_result: {
        group: null,
        dataset: null,
      },
      datasetGroupOptions: [],
      datasetOptions: [],
      query_type: 'sql',

      showResult: false,
      columns: [],
      dataResult: [],
      table_options: {
        headings: {},
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        sortable: [],
        debounce: 1000,
        filterable: true,
        perPage: 10,
        perPageValues: [5, 10, 20, 50, 100],
      },
    };
  },
  computed: {
    ...mapState('jStoreJoana', ['dataset_data']),
  },
  watch: {
    // eslint-disable-next-line
    'data_save_result.group': function (val){
      if (val) {
        const reqData = {
          page: 1,
          limit: 100,
          filter: {
            where_is_and: { datasetgroup_id: val.id },
          },
          sort: { created_at: -1 },
          filter_operator: 'and',
        };
        this.getListDatasetByGroup(reqData).then((res) => {
          this.datasetOptions = res.data;
        });
      }
    },
  },
  created() {
    if (this.dataset_data) {
      this.getDetail();
      this.getListGroupDataset();
      this.dataQuery = `SELECT * FROM ${this.dataset_data.name}\n\n\n\n\n\n\n\n`;
    }
  },
  methods: {
    ...mapMutations('jStoreFormUi', ['setChangesValueView']),
    ...mapActions('jStoreNotificationScreen', ['toggleInfo']),
    ...mapActions('jStoreJoana', ['listQuery', 'runQuery', 'createQuery', 'updateQuery', 'deleteQuery',
      'saveResultQuery', 'getDetailDatasetByGroup', 'getListDataGroup', 'getListDatasetByGroup']),

    getDetail() {
      const req = {
        id: this.dataset_data.id,
      };
      this.getDetailDatasetByGroup(req).then((res) => {
        const dataDetail = res.data || null;
        this.datasetDetail = dataDetail;
        if (dataDetail && dataDetail.column) {
          const columnData = Object.values(dataDetail.column);
          this.datasetColumn = columnData;
          this.definedColumnTable();
        }
      });
    },

    definedColumnTable() {
      this.datasetColumn.forEach((e) => {
        this.columns.push(e.name);
        this.table_options.headings[e.name] = e.name;
        this.table_options.sortable.push(e.name);
      });
    },

    cekTypeColumn(data) {
      const findDataColumn = this.datasetColumn.find(f => f.name === data);
      return findDataColumn ? findDataColumn.type : null;
    },

    actionRunQuery() {
      const query = typeof this.$refs.queryEditor !== 'undefined' ? this.$refs.queryEditor.getData().trim() : '';
      if (query) {
        const param = {
          // eslint-disable-next-line
          query: query.replace(/\n/g, ' ').replace(/\"/g, "'"),
          limit_row: this.select_limit,
          dataset_id: this.dataset_data.id,
          query_type: this.query_type,
        };
        this.runQuery(param).then((res) => {
          if (!res.error) {
            if (res.column.length > 0) {
              this.columns = res.column;
              this.table_options.headings = {};
              this.table_options.sortable = res.column;
              const getColumn = res.column;
              getColumn.forEach((e) => {
                this.table_options.headings[e] = e;
              });
            }
            this.dataResult = res.data;
            this.showResult = true;
          }
        });
      } else {
        this.toggleInfo('Query can not be empty');
      }
    },

    hide() {
      this.opened = false;
    },

    openSaveQuery() {
      const query = typeof this.$refs.queryEditor !== 'undefined' ? this.$refs.queryEditor.getData().trim() : '';
      if (query) {
        if (this.modeQuery === 'create') {
          this.$refs.saveQueryModal.show();
        } else {
          this.opened = true;
        }
      } else {
        this.toggleInfo('Query can not be empty');
      }
    },

    createNewQuery() {
      this.$v.query_name.$touch();
      if (!this.$v.query_name.$invalid) {
        const query = typeof this.$refs.queryEditor !== 'undefined' ? this.$refs.queryEditor.getData().trim() : '';
        const param = {
          // eslint-disable-next-line
          query: query.replace(/\n/g, ' ').replace(/\"/g, "'"),
          name: this.query_name,
          dataset_id: this.dataset_data.id,
          query_type: this.query_type,
        };
        this.createQuery(param).then((res) => {
          if (!res.error) {
            this.modeQuery = 'update';
            this.querySelected = res.data;
            this.closeModalSave();
          }
        });
      }
    },

    actionUpdateQuery() {
      const query = typeof this.$refs.queryEditor !== 'undefined' ? this.$refs.queryEditor.getData().trim() : '';
      if (query) {
        const param = {
          // eslint-disable-next-line
          query: query.replace(/\n/g, ' ').replace(/\"/g, "'"),
          id: this.querySelected.id,
          name: this.querySelected.name,
          dataset_id: this.dataset_data.id,
          query_type: this.query_type,
        };
        this.updateQuery(param);
      } else {
        this.toggleInfo('Query can not be empty');
      }
    },

    openSaveAsQuery() {
      const query = typeof this.$refs.queryEditor !== 'undefined' ? this.$refs.queryEditor.getData().trim() : '';
      if (query) {
        this.query_name = this.querySelected.name || null;
        this.$refs.saveQueryModal.show();
      } else {
        this.toggleInfo('Query can not be empty');
      }
    },

    clearQuery() {
      this.modeQuery = 'create';
      this.querySelected = null;
      this.dataQuery = '\n\n\n\n\n\n\n\n';
      this.showResult = false;
      this.query_type = 'sql';
      this.$refs.queryEditor.changeValue('\n\n\n\n\n\n\n\n');
    },

    actionDeleteQuery(item) {
      this.$swal({
        title: 'Delete Query',
        text: 'Are you sure want to delete this query?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const param = { id: item.id };
          this.deleteQuery(param).then((res) => {
            if (!res.error) {
              this.openListQuery();
              this.clearQuery();
            }
          });
        }
      });
    },

    closeModalSave() {
      this.query_name = null;
      this.$refs.saveQueryModal.hide();

      setTimeout(() => {
        this.$v.query_name.$reset();
      }, 500);
    },

    openListQuery() {
      const param = {
        page: 1,
        limit: 1000000,
        sort: { updated_at: -1 },
        filter: {
          where_is_and: {
            dataset_id: this.dataset_data.id,
          },
        },
        filter_operator: 'and',
      };
      this.listQuery(param).then((res) => {
        if (!res.error) {
          this.listQuerySaved = res.data;
          this.$refs.listSavedQueryModal.show();
        }
      });
    },

    closeModalListSaved() {
      this.$refs.listSavedQueryModal.hide();
    },

    openQuerySelected() {
      this.dataQuery = this.querySelected.query ? `${this.querySelected.query}\n\n\n\n\n` : '';
      this.query_type = this.querySelected.query_type || '';
      this.modeQuery = 'update';
      this.showResult = false;
      this.$refs.queryEditor.changeValue(this.dataQuery);
      this.closeModalListSaved();
    },

    closeModalSaveResult() {
      this.typeMode = '';
      this.data_save_result.group = null;
      this.data_save_result.dataset = null;
      this.$refs.saveResultModal.hide();

      setTimeout(() => {
        this.$v.data_save_result.$reset();
      }, 500);
    },

    actionSaveResultQuery() {
      this.$v.data_save_result.$touch();
      if (!this.$v.data_save_result.$invalid) {
        const query = typeof this.$refs.queryEditor !== 'undefined' ? this.$refs.queryEditor.getData().trim() : '';
        const param = {
          // eslint-disable-next-line
          query: query.replace(/\n/g, ' ').replace(/\"/g, "'"),
          action: this.typeMode,
          dataset_source: this.dataset_data.id,
          dataset_destination: this.data_save_result.dataset.id,
          query_type: this.query_type,
        };
        this.saveResultQuery(param).then((res) => {
          this.closeModalSaveResult();
        });
      }
    },

    getListGroupDataset() {
      const req = {
        page: 1,
        limit: 1000000,
        sort: { updated_at: -1 },
        filter: null,
        filter_operator: 'and',
      };
      this.getListDataGroup(req).then((res) => {
        if (res.data) {
          this.datasetGroupOptions = res.data;
        }
      });
    },

    loadOptionsDataset({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH && searchQuery !== null) {
        if (searchQuery.length > 2) {
          const reqData = {
            page: 1,
            limit: 100,
            filter: {
              where_is_and: { datasetgroup_id: this.data_save_result.group.id },
              where_like_and: { name: searchQuery },
            },
            sort: { created_at: -1 },
            filter_operator: 'and',
          };
          this.$store.dispatch('jStoreJoana/getListDatasetByGroupAsync', { reqData, callback });
        } else {
          callback(null, false);
        }
      }
    },
  },
  validations() {
    return {
      query_name: { required },
      data_save_result: {
        group: { required },
        dataset: { required },
      },
    };
  },
};
</script>

<style lang="scss">
  .input-text-cell-table {
    border: 0px;
    background-color: transparent;
    color: #848689;
    font-size: 12px;
    min-width: 125px;
  }

  .modal-result .modal-dialog {
    max-width: 500px !important;
  }

  .result-label {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/joanadb/dataset/jDatasetQuery.vue